import { Api } from "../util/Api";
import { getDB } from "../util/db";

export class ComponentType {
	static async deleteComponentType(ctype, user) {
		await Api.forProfile(user).inspectionCall(`/v2/component_types/${ctype.id}`, "DELETE");
		let db = await getDB();
		await db.delete("ComponentTypes", ctype.id);
	}

	static async saveComponentType(ctype, user) {
		let data = await Api.forProfile(user).inspectionCall("/v2/component_types", "POST", ctype);
		let db = await getDB();
		await db.put("ComponentTypes", data);
		return data;
	}

	static async syncComponentTypes(user) {
		try {
			let ctypes = await Api.forProfile(user).inspectionCall("/v2/component_types");
			let db = await getDB();
			await db.clear("ComponentTypes");
			for(const ct of ctypes) {
				await db.put("ComponentTypes", ct);
			};
			console.log("Component Types sync'd");
		} catch(err) {
			console.log(`Error syncing Component Types: ${err}`);
		}
	}

	static async getComponentTypeLookup() {
		const db = await getDB();
		const ctypes = await db.getAll("ComponentTypes");
		const ctypeLookup = {};
		for(const ctype of ctypes) {
			ctypeLookup[ctype.id] = ctype;
		}
		return ctypeLookup;
	}
}